
import React, { useEffect, useState, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Dispatch } from "redux";

import { RootState } from "../../store";
import { debugData } from "../../utils/debugData";
import { isEnvBrowser } from "../../utils/misc";
import { useSocketEventOutsideRequest } from "../../hooks/useSocketEventOutsideRequest";
import { socketRequest } from "../../utils/socketRequest";

import { UserState, SET_PLAYERDATA } from "../../reducers/userReducer";
import { PermissionType, PlayerType, HardMoneyState, SET_HOUSEDATA, DEV_SET_property_upgrades } from "../../reducers/hardmoneyReducer";
import { UIState, SET_activeTab, SET_hidden, SET_isLoading } from "../../reducers/uiReducer";

import { IconPrefix, IconName, IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid, regular, light, thin, duotone, brands } from "@fortawesome/fontawesome-svg-core/import.macro";

import { throttle } from 'lodash';
import ProgressBarExtended from "../GlobalComponents/ProgressBar/ProgressBarExtended";

type UpgradeOption = {
    upgradeName: string;
}

type UpgradeDetails = {
  icon: IconDefinition;
  displayName: string;
  displayDescription: string;
};


const UpgradeData: Record<string, UpgradeDetails> = {
  storage: {
    icon: regular("box-circle-check"),
    displayName: "Storage",
    displayDescription: "Gives you more storage slots inside your house.",
  },
  garage: {
    icon: regular("garage"),
    displayName: "Garage Space",
    displayDescription: "This adds an additional parking space to your house. You can store a vehicle in here.",
  },
  security: {
    icon: regular("camera-security"),
    displayName: "Security",
    displayDescription: "This upgrade increases the deficulty to break into your house, plus you will receive a notification when it has been broken into.",
  },
  keys: {
    icon: regular("key"),
    displayName: "More Roommates",
    displayDescription: "This upgrade increases the amount of roommates you can have by 1",
  },
};


const UpgradeOption: React.FC<UpgradeOption> = ({ upgradeName }) => {
    const dispatch = useDispatch();
    const uiData = useSelector((state: RootState) => state.ui);
    const playerData = useSelector((state: RootState) => state.user);
    const hardmoneyData = useSelector((state: RootState) => state.hardmoney);
    const upgradeConst = UpgradeData[upgradeName];

    const houseUpgradeData = hardmoneyData.propertyUpgrades.find(upgrade =>
        upgrade.id == upgradeName
    );
    
    if (!upgradeConst || !houseUpgradeData) {
        return <p>Upgrade not found</p>;
    }

    const maxUpgraded = houseUpgradeData.level >= houseUpgradeData.maxLevel;

    const handlePurchaseUpgrade = (e: React.MouseEvent, canPass: boolean) => {
        e.preventDefault();
        if (!canPass) {
            fetchHouseData();
        };
    };

    const fetchHouseData = useCallback(
        throttle(async () => {
            dispatch(SET_isLoading(true));
            try {
                const res: HardMoneyState = await socketRequest("PurchaseHouseUpgrade", {
                    houseID: hardmoneyData.houseID,
                    houseOwner: hardmoneyData.houseOwner,
                    upgradeName: upgradeName,
                }, hardmoneyData);
                if (res) {
                    if (isEnvBrowser()) {
                        dispatch(DEV_SET_property_upgrades({
                            upgradeID: upgradeName,
                        }))
                    } else {
                        dispatch(SET_HOUSEDATA(res));
                    };
                } else {
                    throw new Error("Invalid house data received.");
                }
            } catch (err) {
                console.error("Error purchase house data:", err);
            } finally {
                dispatch(SET_isLoading(false));
            }
        }, 3000),
        [dispatch]
    );

    return (
        <div
            //className="fadeInPointFive"
            style={{
                width: "100%",
                height: "100%",
                overflow: "hidden",
                boxSizing: "border-box",
                position: "relative",
                //backgroundColor: "yellow",
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                flexDirection: "column",
                padding: "3vh",
                borderRadius: "2vh",
                border: `0.2vh solid rgb(${uiData.schemeColor})`,
                gap: "2vh",
                boxShadow: `0.5vh 0.5vh 1vh rgba(0, 0, 0, 1)`,
                filter: `drop-shadow(0 0 0.5vh rgb(0, 0, 0))`,
            }}
        >
            <div
                style={{
                    width: "100%",
                    height: "auto",
                    //backgroundColor: "gray",
                    fontSize: "1.75vh",
                    fontWeight: "bold",
                    display: "flex",
                    boxSizing: "border-box",
                    justifyContent: "space-between",
                    alignItems: "center",
                    color: maxUpgraded ? "gray" : `rgba(255, 255, 255, 0.9)`
                }}
            >
                <FontAwesomeIcon 
                    icon={upgradeConst.icon}
                    style={{ 
                        width: '5vh', 
                        height: '5vh',
                        color: "rgba(255, 255, 255, 0.9)",
                    }}
                /> 

                {maxUpgraded ? "Unlocked" : `$${houseUpgradeData.amount.toLocaleString("en-US")}`}
            </div>

            <div
                style={{
                    width: "100%",
                    height: "auto",
                    //backgroundColor: "gray",
                    fontSize: "4vh",
                    fontFamily: 'Oswald',
                    fontWeight: "500",
                    display: "flex",
                    boxSizing: "border-box",
                    justifyContent: "space-between",
                    alignItems: "center",
                    color: `rgba(255, 255, 255, 0.9)`
                }}
            >
                {upgradeConst.displayName}
            </div>

            <div
                style={{
                    width: "100%",
                    height: "auto",
                    //sbackgroundColor: "gray",
                    fontSize: "1.6vh",
                    //fontWeight: "bold",
                    display: "flex",
                    boxSizing: "border-box",
                    justifyContent: "space-between",
                    alignItems: "center",
                    color: `gray`,
                }}
            >
                {upgradeConst.displayDescription}
            </div>

            <div
                style={{
                    height: "100%",
                    width: "100%",
                    //backgroundColor: "red",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-end",
                    boxSizing: "border-box",
                    //gap: "1vh",
                }}
            >

                <div
                    style={{
                        height: "4.25vh",
                        width: "60%",
                        boxSizing: "border-box",
                    }}
                >
                    <ProgressBarExtended
                        color={uiData.schemeColor}
                        filledAmount={houseUpgradeData.level}
                        totalAmount={houseUpgradeData.maxLevel}
                    />
                </div>


                <div 
                    onClick={(e) => handlePurchaseUpgrade(e, houseUpgradeData.level >= houseUpgradeData.maxLevel)}
                    style={{
                        border: maxUpgraded ? `0.2vh solid gray` : `0.2vh solid rgb(${uiData.schemeColor})`,
                        backgroundColor: maxUpgraded ? "transparent" : `rgba(${uiData.schemeColor}, 0.1)`,
                        padding: "1.25vh",
                        borderRadius: "1vh",
                        color: "rgba(255, 255, 255, 0.9)",
                        fontSize: "1.25vh",
                        fontWeight: "bold",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        textAlign: "center",
                        cursor: maxUpgraded ?  "auto" : "pointer",
                        boxSizing: "border-box",
                    }}
                >
                    {maxUpgraded ? "Max Level" : "Upgrade"}
                </div>
            </div>
        </div>
    );
};

export default UpgradeOption;
